import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src35513360/src/student-management-ui/app/context/client-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src35513360/src/student-management-ui/components/atoms/Loader.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src35513360/src/student-management-ui/styles/globals.scss");
